import getAgeFromBirthday from './getAgeFromBirthday'

export default function (id) {
  const result = {sex: null, age: null}
  if (id.length === 18) {
    result.sex = Number(id.substr(16, 1)) % 2 === 1 ? 1 : 0
    result.age = getAgeFromBirthday(id.substring(6, 10) + '-' + id.substring(10, 12) + '-' + id.substring(12, 14))
  } else if (id.length === 15) {
    result.sex = Number(id.substr(14, 1)) % 2 === 1 ? 1 : 0
    result.age = getAgeFromBirthday('19' + id.substring(6, 8) + '-' + id.substring(8, 10) + '-' + id.substring(10, 12))
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/getAgeAndSexFromID.js